import { render } from "./designTextareaPreview.vue?vue&type=template&id=27bca156&scoped=true"
import script from "./designTextareaPreview.vue?vue&type=script&lang=js"
export * from "./designTextareaPreview.vue?vue&type=script&lang=js"

import "./designTextareaPreview.vue?vue&type=style&index=0&id=27bca156&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bca156"]])

export default __exports__